"use client";

interface ProductCardPriceProps {
  price: string; // API'den string geliyor: "1.700 ₺"
  listPrice: string; // API'den string geliyor: "1.700 ₺"
  hasDiscount: boolean;
  hasCartSpecialPrice: boolean;
  cartSpecialPriceText?: string;
  currencySymbol?: string;
}

const ProductCardPrice = ({
  price,
  listPrice,
  hasDiscount,
  hasCartSpecialPrice,
  cartSpecialPriceText = "Sepette",
}: ProductCardPriceProps) => {
  const showBasketText = hasCartSpecialPrice || hasDiscount;

  const parsePrice = (s: string) => parseFloat(s.replace(/\./g, "").replace(",", ".")) || 0;
  const showCrossedPrice = hasDiscount && parsePrice(listPrice) > parsePrice(price);

  return (
    <div className="flex flex-col gap-0.5 flex-1">
      <div className="flex items-center gap-1 sm:gap-2">
        {showBasketText && (
          <span className="text-[9px] sm:text-xs font-medium text-main">
            {cartSpecialPriceText}
          </span>
        )}
        <span className="text-xs sm:text-sm font-bold text-main">{price}</span>
      </div>
      {showCrossedPrice && (
        <span className="text-[9px] sm:text-xs text-muted-foreground font-medium line-through">
          {listPrice}
        </span>
      )}
    </div>
  );
};

export default ProductCardPrice;
